<script setup>
import { useEventListener, useLocalStorage } from '@vueuse/core';
import { isEmpty, takeRight } from 'lodash';
import { computed } from 'vue';

const MAX_BOTONES = 5;

const conf = useLocalStorage(
  'botones-login-as',
  {
    botones: {},
    ultimoBoton: undefined,
  },
  { mergeDefaults: true },
);

// Aseguramos los datos, que exista la botonera, que no haya botones borrados etc.
function asegurarBotones() {
  const botones = conf.value.botones || {};
  Object.keys(botones).forEach((id) => {
    if (isEmpty(botones[id])) {
      delete botones[id];
    }
  });

  conf.value.botones = botones;
}

// De todos los botones cogemos los 6 más usados
const botones = computed(() => {
  asegurarBotones();
  let botonesOrdenados = Object.values(conf.value.botones).sort(
    (a, b) => (a.numUsos || 0) - (b.numUsos || 0),
  );

  // En la lista de botones no ponemos el último, éste lo pintamos a parte
  const { ultimoBoton } = conf.value;
  if (ultimoBoton) {
    botonesOrdenados = botonesOrdenados.filter((b) => b.idUsuario !== ultimoBoton.idUsuario);
    botonesOrdenados.push(conf.value.ultimoBoton);
  }

  // Cojemos todos los botones menos uno, añadiremos al final el último login
  botonesOrdenados = takeRight(
    botonesOrdenados,
    MAX_BOTONES,
  );

  return botonesOrdenados;
});

function isUltimoBoton(boton) {
  return boton.idUsuario === conf.value.ultimoBoton?.idUsuario;
}

function classBoton(boton) {
  const ultimo = isUltimoBoton(boton);
  return {
    'btn-success': ultimo,
    'btn-default': !ultimo,
  };
}

function guardarNuevoLogin(loginInfo) {
  let boton = conf.value.botones[loginInfo.usuario_id];
  if (!boton) {
    boton = {
      idUsuario: loginInfo.usuario_id,
      numUsos: 0,
    };
    conf.value.botones[loginInfo.usuario_id] = boton;
  }

  if (loginInfo.usuario_usuario?.startsWith('director_')) {
    boton.label = loginInfo.centro_nombre;
    boton.title = loginInfo.usuario_nombre;
  } else {
    boton.label = loginInfo.usuario_nombre;
    boton.title = loginInfo.centro_nombre;
  }

  boton.numUsos = (boton.numUsos || 0) + 1;
  conf.value.ultimoBoton = boton;
}

function seleccionarBoton(boton) {
  boton.numUsos += 1;
}

function borrarBoton(boton) {
  delete conf.value.botones[boton.idUsuario];
  if (isUltimoBoton(boton)) {
    conf.value.ultimoBoton = null;
  }
}

useEventListener(document.querySelector('.cifra-listado-body'), 'click', (event) => {
  if (event.target.matches('.link-login-as i')) {
    const loginInfo = JSON.parse(event.target.dataset.loginInfo);
    guardarNuevoLogin(loginInfo);
  }
});
</script>

<template>
  <div>
    <div
      v-for="boton in botones"
      :key="boton.idUsuario"
      class="btn-group btn-group-sm m-r-xs"
      role="group"
    >
      <a
        class="btn"
        :class="classBoton(boton)"
        :title="boton.title"
        :usuario_id="boton.idUsuario"
        data-toggle="tooltip"
        :href="`/admin/login_as_do/${boton.idUsuario}`"
        @click="seleccionarBoton(boton)"
      >
        {{ boton.label }}
      </a>
      <button
        type="button"
        class="btn btn-eliminar"
        :class="classBoton(boton)"
        @click="borrarBoton(boton)"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .btn {
    letter-spacing: 0;
  }
  .btn-eliminar {
    padding-left: 5px;
    padding-right: 5px;
  }
</style>
<style lang="scss">
  // css global!! Esta ñapa es para ajustar los márgenes arriba y abajo de la botonera
  [data-action="login_as"] {
    .filters-wrapper,
    #botones-accion-listado {
      margin-bottom: 12px;
    }
  }
</style>
